import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import Form from '@appComponents/ReduxFormControls';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {ContentTypesFilter} from '@utils/commonFilters/ContentTypesFilter';
import {ContentVariantsFilter} from '@utils/commonFilters/ContentVariantsFilter';
import {DistributionTypesFilter} from '@utils/commonFilters/DistributionTypesFilter';
import {DeviceCategoriesFilter} from '@utils/commonFilters/DeviceCategoriesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {EventContentsFilter} from '@utils/commonFilters/EventContentsFilter';

const EventStreamsFilters = (props) => {
    return (
        <div className='eventStreams__filters filter__controls__container'>
            <SearchFilter
                loading={props.loading}
                filters={props.filters.EventsStreams}
                restoreFilterValues={props.restoreFilterValues}
            />
            <EventContentsFilter
                loading={props.loading}
                filters={props.filters.EventsStreams}
                restoreFilterValues={props.restoreFilterValues}
                options={props.data.eventContents}
            />
            <ContentTypesFilter
                eventContentTypes={props.data.eventContentTypes}
                loading={props.loading}
                filters={props.filters.EventsStreams}
                restoreFilterValues={props.restoreFilterValues}
            />
            <ContentVariantsFilter
                eventContentVariants={props.data.eventContentVariants}
                loading={props.loading}
                filters={props.filters.EventsStreams}
                restoreFilterValues={props.restoreFilterValues}
            />
            <ProductsFilter
                loading={props.loading}
                products={props.data.products}
                filters={props.filters.EventsStreams}
                restoreFilterValues={props.restoreFilterValues}
            />
            <DistributionTypesFilter
                distributionTypes={props.data.distributionTypes}
                loading={props.loading}
                filters={props.filters.EventsStreams}
                restoreFilterValues={props.restoreFilterValues}
            />
            <Field
                component={Form.ReduxSelect}
                name='streamDelayTypes'
                options={props.data.streamDelayTypes}
                disabled={props.loading}
                placeholder='Stream delay type'
                loading={props.loading}
                setValue={props.restoreFilterValues(props.filters.EventsStreams, 'streamDelayTypes')}
                multiple
                selection
            />
            <DeviceCategoriesFilter
                deviceCategories={props.data.deviceCategories}
                loading={props.loading}
                filters={props.filters.EventsStreams}
                restoreFilterValues={props.restoreFilterValues}
            />
            <Field
                component={Form.ReduxSelect}
                name='formats'
                className='short'
                options={props.data.streamFormats}
                disabled={props.loading}
                placeholder='Format'
                loading={props.loading}
                setValue={props.restoreFilterValues(props.filters.EventsStreams, 'formats')}
                multiple
                selection
            />
            <Field
                component={Form.ReduxSelect}
                name='protocols'
                className='short'
                options={props.data.streamProtocols}
                disabled={props.loading}
                placeholder='Protocol'
                loading={props.loading}
                setValue={props.restoreFilterValues(props.filters.EventsStreams, 'protocols')}
                multiple
                selection
            />
            <Field
                component={Form.ReduxSelect}
                name='streamStatuses'
                options={props.data.streamStatuses}
                disabled={props.loading}
                placeholder='Status'
                loading={props.loading}
                setValue={props.restoreFilterValues(props.filters.EventsStreams, 'streamStatuses')}
                multiple
                selection
            />
        </div>
    );
};

EventStreamsFilters.propTypes = {
    data: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func,
};

EventStreamsFilters.defaultProps = {
    loading: false,
};

export default FiltersWrapper(EventStreamsFilters, {name: 'EventsStreams'});
